import React from 'react';
interface ISvgIconProps {
  iconId: string;
  className?: string;
  onClick?: any;
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
  title?: string;
}

interface IIcons {
  [Key: string]: {
    viewBox: string;
    content: JSX.Element;
  };
}

const SvgIcons = ({
  iconId,
  className = '',
  onClick,
  fill = 'currentColor',
  stroke = 'currentColor',
  strokeWidth = '20px',
  title = ''
}: ISvgIconProps) => (
  <svg
    onClick={onClick}
    className={className}
    viewBox={icons[iconId].viewBox}
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
  >
    <>
      <title>{title}</title>
      {icons[iconId].content}
    </>
  </svg>
);

export default SvgIcons;

const icons: IIcons = {
  play: {
    viewBox: '0 0 400 400',
    content: (
      <>
        <circle cx="200" cy="200" r="180" fill="white" />
        <polygon points="280,200 160,280 160,120" fill="white" />
      </>
    )
  },
  pause: {
    viewBox: '0 0 400 400',
    content: (
      <>
        <circle cx="200" cy="200" r="180" fill="white" />
        <rect x="120" y="120" width="60" height="160" fill="white" />
        <rect x="220" y="120" width="60" height="160" fill="white" />
      </>
    )
  },
  stop: {
    viewBox: '0 0 400 400',
    content: (
      <>
        <circle cx="200" cy="200" r="180" fill="white" />
        <rect x="120" y="120" width="160" height="160" fill="white" />
      </>
    )
  },
  edit: {
    viewBox: '0 0 32 32',
    content: (
      <path
        d="M27 0c2.761 0 5 2.239 5 5 0 1.126-0.372 2.164-1 3l-2 2-7-7 2-2c0.836-0.628
      1.874-1 3-1zM2 23l-2 9 9-2 18.5-18.5-7-7-18.5 18.5zM22.362 11.362l-14 14-1.724-1.724 14-14 1.724 1.724z"
      />
    )
  },
  add: {
    viewBox: '0 0 32 32',
    content: (
      <path
        d="M31 12h-11v-11c0-0.552-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1v11h-11c-0.552 0-1 0.448-1 1v6c0 0.552 0.448 1 1
      1h11v11c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1v-11h11c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1z"
      />
    )
  },
  move: {
    viewBox: '0 0 1024 1024',
    content: (
      <path d="M384 768 384 640 213.333333 640 213.333333 469.333333 384 469.333333 384 341.333333 597.333333 554.666667M853.333333 256 512 256 426.666667 170.666667 170.666667 170.666667C123.306667 170.666667 85.333333 208.64 85.333333 256L85.333333 768C85.333333 814.933333 123.733333 853.333333 170.666667 853.333333L853.333333 853.333333C900.266667 853.333333 938.666667 814.933333 938.666667 768L938.666667 341.333333C938.666667 293.973333 900.266667 256 853.333333 256Z" />
    )
  },
  delete: {
    viewBox: '0 0 32 32',
    content: (
      <path
        d="M31.708 25.708c-0-0-0-0-0-0l-9.708-9.708 9.708-9.708c0-0 0-0 0-0 0.105-0.105 0.18-0.227 0.229-0.357
      0.133-0.356 0.057-0.771-0.229-1.057l-4.586-4.586c-0.286-0.286-0.702-0.361-1.057-0.229-0.13 0.048-0.252 0.124-0.357
      0.228 0 0-0 0-0 0l-9.708 9.708-9.708-9.708c-0-0-0-0-0-0-0.105-0.104-0.227-0.18-0.357-0.228-0.356-0.133-0.771
      -0.057-1.057 0.229l-4.586 4.586c-0.286 0.286-0.361 0.702-0.229 1.057 0.049 0.13 0.124 0.252 0.229 0.357 0 0 0 0
      0 0l9.708 9.708-9.708 9.708c-0 0-0 0-0 0-0.104 0.105-0.18 0.227-0.229 0.357-0.133 0.355-0.057 0.771 0.229
      1.057l4.586 4.586c0.286 0.286 0.702 0.361 1.057 0.229 0.13-0.049 0.252-0.124 0.357-0.229 0-0 0-0 0-0l9.708
      -9.708 9.708 9.708c0 0 0 0 0 0 0.105 0.105 0.227 0.18 0.357 0.229 0.356 0.133 0.771 0.057 1.057-0.229l4.586
      -4.586c0.286-0.286 0.362-0.702 0.229-1.057-0.049-0.13-0.124-0.252-0.229-0.357z"
      />
    )
  },
  search: {
    viewBox: '0 0 1024 1024',
    content: (
      <path d="M1000.944149 889.443492 815.920946 704.484333C866.643818 631.794359 896.616424 543.605729 896.616424 448.308212c0-247.594221-200.713991-448.308212-448.308212-448.308212C200.713991 0 0 200.713991 0 448.308212c0 247.594221 200.713991 448.308212 448.308212 448.308212 95.297517 0 183.486147-29.972606 256.176121-80.695478l184.959159 184.959159c30.805179 30.805179 80.695478 30.805179 111.500657 0C1031.685284 970.138971 1031.685284 920.248671 1000.944149 889.443492zM448.308212 768.528363c-176.825568 0-320.220151-143.394584-320.220151-320.220151 0-176.825568 143.394584-320.220151 320.220151-320.220151s320.220151 143.394584 320.220151 320.220151C768.528363 625.133779 625.133779 768.528363 448.308212 768.528363z" />
    )
  },
  logout: {
    viewBox: '0 0 1024 1024',
    content: (
      <path d="M511.995 914.711107c-49.870951 0-98.280904-9.77799-143.86286-29.060972-44.011957-18.614982-83.536918-45.249956-117.459885-79.183923-33.928967-33.925967-60.565941-73.446928-79.180922-117.454885-19.288981-45.590955-29.060972-93.989908-29.060972-143.868859 0-135.626868 74.096928-260.140746 193.380811-324.937683 20.23198-10.987989 45.542956-3.500997 56.535945 16.731984 10.993989 20.23098 3.502997 45.547956-16.733984 56.534944-92.40091 50.197951-149.806854 146.632857-149.806854 251.669755 0 157.803846 128.384875 286.188721 286.187721 286.18872S798.179721 702.945314 798.179721 545.142468c0-103.528899-56.182945-199.296805-146.630857-249.920756-20.08998-11.246989-27.263973-36.652964-16.012985-56.741945 11.241989-20.09198 36.652964-27.267973 56.736945-16.017984 56.387945 31.560969 103.749899 77.555924 136.975866 133.01387 34.219967 57.147944 52.319949 122.72888 52.319949 189.666815 0 49.878951-9.78399 98.277904-29.064972 143.868859-18.617982 44.007957-45.251956 83.535918-79.175922 117.454885-33.931967 33.933967-73.452928 60.568941-117.469885 79.187923-45.577955 19.278981-93.992908 29.056972-143.86286 29.056972z m0-398.266611c-25.318975 0-45.848955-20.52098-45.848955-45.844956V155.137848c0-25.320975 20.52898-45.849955 45.848955-45.849955s45.849955 20.52798 45.849955 45.849955v315.462692c0 25.322975-20.53098 45.843955-45.849955 45.843956z" />
    )
  },
  empty: {
    viewBox: '0 0 780 980',
    content: (
      <g transform="translate(0.000000,980.000000) scale(0.100000,-0.100000)">
        <path
          d="M7145 9790 c-101 -21 -204 -78 -267 -148 -18 -20 -262 -352 -542
    -737 -280 -385 -513 -704 -517 -709 -4 -4 -90 32 -191 82 -506 249 -987 374
    -1551 402 -943 47 -1866 -255 -2621 -858 -149 -119 -452 -419 -572 -567 -485
    -599 -771 -1282 -860 -2050 -21 -181 -24 -611 -6 -785 18 -169 58 -400 97
    -559 167 -681 530 -1326 1019 -1811 64 -63 116 -118 116 -123 0 -4 -188 -265
    -417 -580 -229 -314 -429 -597 -444 -627 -36 -72 -49 -128 -49 -220 0 -91 12
    -145 48 -219 36 -75 137 -180 210 -219 186 -99 412 -74 569 63 30 26 209 264
    477 632 l430 590 115 -57 c889 -445 1968 -520 2926 -205 1264 417 2240 1463
    2564 2750 83 329 115 596 114 955 0 286 -14 455 -59 700 -137 747 -496 1448
    -1023 1993 -89 92 -94 99 -82 120 8 12 241 334 519 716 278 382 519 719 535
    748 40 74 57 144 57 234 0 131 -46 245 -138 342 -119 124 -293 180 -457 147z
    m-2959 -2121 c232 -23 491 -83 711 -165 85 -32 299 -127 311 -138 3 -4 -3325
    -4584 -3350 -4611 -7 -6 -32 15 -74 60 -427 463 -688 1030 -760 1651 -22 192
    -15 586 14 764 70 426 218 807 448 1152 479 719 1225 1179 2077 1282 138 17
    476 20 623 5z m1970 -1074 c344 -424 561 -948 624 -1510 15 -136 12 -481 -5
    -630 -133 -1134 -919 -2082 -2013 -2428 -477 -152 -987 -172 -1490 -62 -208
    46 -600 188 -590 214 1 6 752 1039 1667 2297 l1665 2287 39 -44 c21 -24 67
    -80 103 -124z"
        />
      </g>
    )
  },
  tick: {
    viewBox: '0 0 600 600',
    content: (
      <g transform="translate(0.000000,600.000000) scale(0.100000,-0.100000)">
        <path
          d="M5270 5869 c-171 -21 -364 -75 -484 -136 -423 -214 -1103 -1026
          -1873 -2238 -334 -526 -675 -1115 -849 -1467 l-58 -117 -42 -7 c-80 -12 -212
          32 -321 107 -147 101 -360 359 -518 624 -10 16 -71 -22 -525 -325 -283 -188
          -519 -346 -523 -350 -4 -4 54 -79 130 -166 573 -660 1055 -1294 1198 -1577
          l50 -97 499 2 498 3 14 35 c7 19 39 105 70 190 206 563 642 1457 1083 2223
          487 848 985 1572 1473 2146 165 193 514 545 671 675 122 101 151 139 163 214
          17 110 -73 196 -254 243 -90 23 -292 32 -402 18z"
        />
      </g>
    )
  }
};
